import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Navbar } from "./components/layout/Navbar";
import { HomePage } from "./pages/HomePage";
import { ChatPage } from "./pages/ChatPage";
import { ExercisesPage } from "./pages/ExercisesPage";
import { JournalPage } from "./pages/JournalPage";
import { TermsPage } from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import { ExamplePage } from "./pages/ExamplePage";
import { Toaster } from "./components/ui/sonner";

// Breathing Pixels Background Component
function BreathingPixels() {
    return (
        <div className="breathing-bg">
            {[...Array(30)].map((_, i) => (
                <div key={i} className={`pixel ${i % 3 === 0 ? 'glow' : ''}`} />
            ))}
        </div>
    );
}

function App() {
    // Register Service Worker for PWA
    useEffect(() => {
        if ('serviceWorker' in navigator) {
            window.addEventListener('load', () => {
                navigator.serviceWorker.register('/service-worker.js')
                    .then((registration) => {
                        console.log('SW registered:', registration.scope);
                    })
                    .catch((error) => {
                        console.log('SW registration failed:', error);
                    });
            });
        }
    }, []);

    return (
        <LanguageProvider>
            <div className="App min-h-screen bg-[#0A0F0D] relative">
                <BreathingPixels />
                <BrowserRouter>
                    <div className="relative z-10">
                        <Navbar />
                        <main>
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/chat" element={<ChatPage />} />
                                <Route path="/chat/:category" element={<ChatPage />} />
                                <Route path="/chat/:category/:conversationId" element={<ChatPage />} />
                                <Route path="/exercises" element={<ExercisesPage />} />
                                <Route path="/exercises/:exerciseId" element={<ExercisesPage />} />
                                <Route path="/journal" element={<JournalPage />} />
                                <Route path="/journal/:entryId" element={<JournalPage />} />
                                <Route path="/terms" element={<TermsPage />} />
                                <Route path="/privacy" element={<PrivacyPage />} />
                                <Route path="/example/:type" element={<ExamplePage />} />
                            </Routes>
                        </main>
                    </div>
                    <Toaster position="bottom-right" />
                </BrowserRouter>
            </div>
        </LanguageProvider>
    );
}

export default App;
